<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      向西村站<br>
站点介绍<br>
向西村站位于春风路与东门南路交叉路口处的春风路下。A1出入口旁是文锦渡海关生活区，B出入口前方有华润万家，B出入口右侧不远处是向西小学及深圳市罗湖区人民医院（春风院区），C出入口前方有向西花园。向西村站装修设计采用白色+紫色色彩基调，站台为上下两层重叠的侧式站台。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:21	23:01	9号线	3分50秒	5分55秒<br>
文锦	06:26	00:07	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:21	23:01	9号线	4分25秒	5分55秒<br>
文锦	06:25	00:07	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:21	00:01	9号线	4分钟	5分55秒<br>
文锦	06:23	01:07	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A1出入口:<br>
东门南路北侧（东）、潮汕大厦、惠州大厦、中国海关、文锦渡口岸大楼<br><br>
A2出入口:<br>
春风路东侧（南）、深圳市罗湖中学、广西大厦<br><br>
B出入口:<br>
凯悦华庭、云景豪园、深圳市向西小学、春风路东侧（北）、罗湖医院春风院区、文锦渡海关<br><br>
C出入口:<br>
春风路西侧（北）、向西花园<br><br>
D1出入口:<br>
宝丰大厦、东门南路北侧（西）<br><br>
D2出入口:<br>
广发大厦、罗湖医院、深圳市南湖小学、春风路西侧（南）<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 春风万佳<br>
M156路（原336路）、 M182路（原382路）、 E26路,NE26（原N29路）、高快巴士26、M205、E17<br><br>
B出入口:<br>
公交站名： 罗湖医院春风院区<br>
381路、5路、14路、69路、83路、229路、M172（原372路）<br><br>
C出入口:<br>
公交站名： 春风万佳<br>
M156路（原336路）、M182路（原382路）、E26路、M172路（原372路）、高快巴士26、M205路、E17<br><br>
C出入口:<br>
公交站名： 罗湖医院春风院区<br>
381路、5路、14路、69路、83路、229路<br><br>
D1出入口:<br>
公交站名： 丽都酒店①<br>
369路、14路、229路、M156路（原336路）、381路、5路、83路、97路、M205路<br><br>
D1出入口:<br>
公交站名： 丽都酒店②<br>
69路<br><br>
D2出入口:<br>
公交站名： 丽都酒店①<br>
369路<br><br>
D2出入口:<br>
公交站名： 丽都酒店②<br>
M156路、381路、5路、14路、69路、83路、97路、229路、M205路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>